import List from "./Pages/List";
import Add from "./Pages/Add";
import Edit from "./Pages/Edit";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

//const API_URL = 'http://localhost:64909/gym';
const API_URL = 'https://jsonplaceholder.typicode.com/users';
const router = createBrowserRouter([
  {path: '/', element: <List apiUrl={API_URL} />},
  {path: '/add', element: <Add apiUrl={API_URL}/>},
  {path: '/edit/:id', element: <Edit apiUrl={API_URL}/>},
  {path: '*', element: <List apiUrl={API_URL}/>}
])

function App() {
  return <RouterProvider router={router} />;
}

export default App;
